var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"event-add-view"},[_c('h1',[_vm._v(" Новый отель ")]),_c('hotel-form')],1)}
var staticRenderFns = []

export { render, staticRenderFns }